import type { LalSegmentFormState } from '@openx/types/segments';

interface MappedData {
  definition: {
    account_id: string;
    lookalike_name: string;
    provider_id: string;
    status: string;
    lookalike_seeds_aggregate_name: string;
    seeds_estimated_reach: number;
  };
  seedSegmentIds: string[];
}

export const mapFormStateToCreateLookalike = (formData: LalSegmentFormState): MappedData => {
  return {
    definition: {
      account_id: formData.account_id,
      lookalike_name: formData.name,
      provider_id: formData.provider.id,
      status: 'processing',
      lookalike_seeds_aggregate_name: formData.seed_name,
      seeds_estimated_reach: formData.estimated_reach,
    },
    seedSegmentIds: formData.seeds.map(seed => seed.id),
  };
};
